import type { AnalyticsEventName, AnalyticsProperties } from './events';
import type { TrackOptions } from './sinks';
import { getSinks } from './sinks';

export type { AnalyticsEventName, AnalyticsProperties } from './events';
export type { TrackOptions } from './sinks';

/**
 * Emit an analytics event to every enabled destination.
 *
 * Deliberately unchanged in signature: this is called from ~60 sites, and the
 * multi-destination fan-out was introduced without touching any of them. Sinks
 * are registered in src/index.tsx; see ./sinks for why they live in a registry.
 */
export function track(
  event: AnalyticsEventName,
  properties?: AnalyticsProperties,
  options?: TrackOptions
): void {
  getSinks().forEach((sink) => {
    // Per-sink isolation. A throwing or misconfigured sink must not cost the
    // others their event — before the fan-out there was one destination and one
    // try/catch, and collapsing them into a single outer catch would silently
    // make PostHog delivery depend on HubSpot's health.
    try {
      if (!sink.isEnabled()) return;
      sink.capture(event, properties, options);
    } catch (err) {
      if (import.meta.env.DEV) {
        // eslint-disable-next-line no-console
        console.warn('[analytics] capture failed', sink.name, event, err);
      }
    }
  });
}
